const getControlHeight = (size) => {
  if (size === 'l') return 40;
  if (size === 'm') return 34;
  if (size === 's') return 30;
  return 34;
};

const getSizeUnit = (size) => {
  if (size === 'l') return 4;
  if (size === 'm') return 2;
  if (size === 's') return 2;
  return 2;
};

const DefaultTheme = (theme, size) => {
  const dTheme = {
    ...theme,
    colors: {
      ...theme.colors,
      danger: 'var(--danger-02)',
      dangerLight: 'var(--danger-01)',
      primary: 'var(--color-main-05)',
      primary25: 'var(--color-main-03)',
      primary50: 'var(--color-main-02)',
      primary75: 'var(--color-main-01)',
    },
    spacing: {
      ...theme.spacing,
      controlHeight: getControlHeight(size),
      baseUnit: getSizeUnit(size),
    },
  };

  return dTheme;
};

export default DefaultTheme;
